/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/11
 */
import './index.css';
import React from 'react';

const Footer = ({ items }) => {
  return <div className="mcycle-step-footer">
    {items.map((item, index) =>
      <div className="mcycle-step-footer-item" key={index}>
        {item.icon}
        <p className="mcycle-step-footer-title">{item.title}</p>
        <div className="mcycle-step-footer-details">
          {item.detail.map((detail, i) =>
            <p className="mcycle-step-footer-detail" key={i}>{detail}</p>
          )}
        </div>
      </div>
    )}
  </div>
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/step/footer/index.js